import {Link} from "react-router-dom";
import styled from "styled-components";

import useSetPreset from "../hooks/useSetPreset";
import {designers} from "../utils/designers";
import ReactPlayer from "react-player";
import Footer from "../components/molecules/Footer";

const Holder = styled.div`
  margin: 4rem 2rem;

  h1 {
    text-align: center;
    margin: 0 0 4rem 0;
  }
`;
const Tile = styled.li`
  p {
    margin: 0;

    a {
      font-weight: bold;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    &.quote {
      ${(props) => props.theme.fluidType(1)};
      margin: 1rem 0;
    }
  }

  h2 {
    margin-bottom: 0;
  }
`;

const StyledGallery = styled.ul`
  position: relative;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 2rem;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const VideoHolder = styled.div`
  position: relative;
  aspect-ratio: 1;
  background-color: ${(props) => `${props.theme.colors.color1}0D`};
`;


const Gallery = () => {
  const {setPreset} = useSetPreset();

  return (
    <>
      <Holder>
        <h1>Designer Gallery</h1>
        <StyledGallery>
          {designers.map((designer, i) => (
            <Tile key={i}>

              <VideoHolder>
                <ReactPlayer
                  className="react-player"
                  url={designer.video.url}
                  width="100%"
                  height="100%"
                  muted={true}
                  playing={true}
                  loop={true}
                  controls={false}
                  playsinline={true}
                />
              </VideoHolder>


              <h2>{designer.name}</h2>
              <p>{designer.nationality}</p>
              <p>{designer.role}</p>
              <p className="quote">"{designer.quote}"</p>
              <p><Link
                to="/fvs-tool/"
                className="video-info"
                onClick={() => setPreset(designer.preset)}
              >Use design in tool</Link></p>
            </Tile>
          ))}
        </StyledGallery>
      </Holder>
      <Footer />
    </>
  );
};

export default Gallery;
